import { Box, Container, Typography, Divider, Chip, Avatar } from "@mui/material";
import { format } from "date-fns";
import { useGetPublicSchoolInfoQuery } from "../../../../../app/authApiSlice";
import { useGetWebsiteSettingsQuery } from "../../../../../app/websiteApiSlice";
import WebsiteHeader from "../../WebsiteHeader";
import WebsiteFooter from "../../WebsiteFooter";
import SeoHead from "../../SeoHead";
import BlockRenderer from "../../BlockRenderer";
import "./modern.css";

export default function ModernPage({ page, settings: settingsProp }) {
  const { data: school } = useGetPublicSchoolInfoQuery();
  const { data: settings } = useGetWebsiteSettingsQuery(undefined, { skip: !!settingsProp });
  const activeSettings = settingsProp || settings;

  return (
    <Box className="website-modern" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <SeoHead
        title={page.seo_title || page.title}
        description={page.seo_description}
        ogImage={page.seo_og_image}
        schoolName={school?.name}
      />
      <WebsiteHeader school={school} navItems={activeSettings?.nav_items} variant="modern" />

      <BlockRenderer blocks={page.page_blocks} />

      {page.featured_image && !page.page_blocks?.length && (
        <Box
          component="img"
          src={page.featured_image}
          alt={page.title}
          sx={{ width: "100%", maxHeight: 400, objectFit: "cover" }}
        />
      )}

      {(page.content?.trim() || !page.page_blocks?.length) && (
        <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
          {!page.page_blocks?.length && (
            <Typography variant="h3" fontWeight={800} gutterBottom>
              {page.title}
            </Typography>
          )}
          {!page.page_blocks?.length && <Divider sx={{ mb: 4 }} />}
          {page.content?.trim() && (
            <Box
              className="prose-content"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          )}
        </Container>
      )}

      <WebsiteFooter settings={activeSettings} school={school} variant="modern" />
    </Box>
  );
}
